module.exports = __webpack_public_path__ + "img/travels.a231ae13.png";